"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Building2, TrendingUp, Briefcase } from "lucide-react";
export default function RealEstateServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const services = [{
    id: 1,
    icon: Building2,
    label: "Property Sourcing",
    description: "Expert identification of high-value real estate opportunities across Nigeria",
    path: "/ServicesPage"
  }, {
    id: 2,
    icon: TrendingUp,
    label: "Investment Analysis",
    description: "Data-driven insights to maximize your property investment returns",
    path: "/ServicesPage"
  }, {
    id: 3,
    icon: Briefcase,
    label: "Portfolio Management",
    description: "Comprehensive management solutions for your real estate assets",
    path: "/ServicesPage"
  }];
  return <section ref={ref} className="relative bg-dark-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-12">
          <h2 className={`text-3xl md:text-4xl lg:text-5xl font-display font-bold text-foreground-dark mb-4 transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            Real Estate Services
          </h2>
          <p className={`text-lg text-foreground-dark/80 max-w-2xl mx-auto transition-all duration-[var(--duration-medium)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            Comprehensive solutions for property acquisition, analysis, and management
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Link key={service.id} to={service.path} data-index={i} className="block group">
                <Card className={`h-full bg-dark-background border-2 border-muted-dark/30 hover:border-primary/50 shadow-soft hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
              transitionDelay: isVisible ? `${i * 100}ms` : "0ms"
            }}>
                  <CardContent className="flex flex-col items-center text-center py-10 px-6">
                    <div className="mb-6 p-4 rounded-full bg-primary/10 group-hover:bg-primary/20 transition-colors duration-[var(--duration-medium)]">
                      <Icon className="w-12 h-12 text-primary" strokeWidth={1.5} />
                    </div>
                    <h3 className="text-xl md:text-2xl font-display font-semibold text-foreground-dark mb-3 relative">
                      {service.label}
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary group-hover:w-full transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" />
                    </h3>
                    <p className="text-foreground-dark/70 leading-relaxed">
                      {service.description}
                    </p>
                  </CardContent>
                </Card>
              </Link>;
        })}
        </div>
      </div>
    </section>;
}